export default class StreamAgendaUtility {
  constructor(item) {
    this.UPDATE_INTERVAL = 5000; // in milliseconds
    this.now = new Date();
    this.isLive = false;
    this.interval = null;
    this.item = item;
  }

  /**
   * Initializes the interval for updating live/pre-live status
   */
  initInterval() {
    this.updateValues();
    this.interval = setInterval(() => this.updateValues(), this.UPDATE_INTERVAL);
  }

  clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  /**
   * Updates the live values based on the current time
   */
  updateValues() {
    this.now = new Date();
    this.isLive = this.getIsLive(this.item);
  }

  /**
   * Determines if the stream is live (between start and end times with a tolerance)
   * @param {Object} programItem - The current program item
   * @returns {boolean} - true if stream is live
   */
  getIsLive(programItem) {
    if (programItem && programItem.fp_starttime && programItem.fp_endtime) {
      // display stream 10 minutes (in milliseconds) before official start
      const futureStartTimestamp = this.now.getTime() + (10 * 60 * 1000);
      const futureStart = new Date(futureStartTimestamp);

      const startDate = new Date(programItem.fp_starttime);
      const endDate = new Date(programItem.fp_endtime);

      return startDate <= futureStart && endDate >= this.now;
    }
    return false;
  }
}
